import React from 'react'
import styles from './styles.css'
import {withRouter, Link} from 'react-router'
import PropTypes from 'prop-types'
import withOrganization from 'App/Decorators/withOrganization'
import Counter from './counter'

@withOrganization
@withRouter
export default class Main extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.node,
    organization: PropTypes.object
  }

  getLinks() {
    if (
      this.props.organization.myRole[0] === 'owner' ||
      this.props.organization.myRole[0] === 'admin'
    ) {
      return [
        {
          title: 'Organización',
          path: `/organization/users`,
          prop: 'usersCount'
        },
        {title: 'Ajustes', path: `/organization/info`}
      ]
    } else {
      return [
        {
          title: 'Organización',
          path: `/organization/users`,
          prop: 'usersCount'
        }
      ]
    }
  }

  renderLinks() {
    const links = this.getLinks()
    return links.map((link, index) => {
      const isActive = this.props.router.location.pathname === link.path
      return (
        <div key={index} onClick={link.onClick} className={isActive ? 'active' : ''}>
          <Link to={link.path}>
            {link.prop && <Counter organization={this.props.organization._id} link={link} />}{' '}
            {link.title}
          </Link>
        </div>
      )
    })
  }

  render() {
    if (!this.props.organization) return
    return (
      <div className={styles.container}>
        <div className="tabs">{this.renderLinks()}</div>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Organizations/Layout/index.js